<template>
  <form
    class="contact-form"
    @submit.prevent="submitForm"
  >
    <TextInput
      v-model="formData.fullName"
      label="Full Name"
      type="text"
      required
      class="col-span-12 md:col-span-6 mb-1"
      :validation-error="errors && 'fullName' in errors && errors.fullName[0]"
    />

    <TextInput
      v-model="formData.email"
      label="Email Address"
      required
      class="col-span-12 md:col-span-6 mb-1"
      :validation-error="errors && 'email' in errors && errors.email[0]"
    />

    <TextInput
      v-model="formData.phoneNumber"
      label="Contact Number"
      required
      type="tel"
      class="col-span-12 md:col-span-6 mb-1"
      :validation-error="errors && 'phoneNumber' in errors && errors.phoneNumber[0]"
    />

    <TextareaInput
      v-model="formData.message"
      label="Message"
      required
      class="col-span-12 mb-3"
      :validation-error="errors && 'message' in errors && errors.message[0]"
    />

    <div class="col-span-12">
      <AppButton
        class="btn btn-solid bg-white text-secondary px-8 hover:bg-secondary hover:text-white border-0"
        :processing="isSubmitting"
      >
        Submit
        <FontAwesomeIcon :icon="faArrowRight" />
      </AppButton>
    </div>
  </form>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { reactive } from 'vue';

import { AppButton } from '@/components/app';
import { TextInput, TextareaInput } from '@/components/forms/inputs';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';

import { useFormSubmit, useHttp } from '@/composables';
import { useAuthStore } from '@/store';

const authStore = useAuthStore();

const emit = defineEmits(['submit']);

const { isSubmitting, errors } = useFormSubmit();

const formData = reactive({
  fullName: import.meta.env.DEV ? 'test' : (authStore.user?.firstName ? authStore.user.firstName : '' + (authStore.user?.lastName ? ' ' + authStore.user.lastName : '')),
  email: import.meta.env.DEV ? 'test@gmail.com' : (authStore?.user?.email || null),
  phoneNumber: import.meta.env.DEV ? '063 123 1230' : (authStore?.user?.phoneNumber || null),
  message: import.meta.env.DEV ? 'test' : null,
  type: 'Contact Us',
});

const submitForm = async () => {
  errors.value = null;
  isSubmitting.value = true;

  let validFormData = { ...formData };
  validFormData.phoneNumber = formData.phoneNumber.replace(/ /g, '');

  const response = await useHttp().post('/contact-us', validFormData);

  if (response.statusCode === HttpStatusCode.Ok) {
    emit('submit');

    for (const item in formData) {
      formData[item] = null;
    }

    formData.type = 'Contact Us';
  } else if (response.statusCode === HttpStatusCode.UnprocessableEntity) {
    errors.value = response.errors;
  }

  isSubmitting.value = false;
};

</script>
